(ns ductile.ui.contract
  (:require [clojure.string :as str]
            [clojure.walk :as w]
            [ductile.schema :as schema]
            [ductile.time.format :as time.format]
            [ductile.ui.billing :as billing-ui]
            [ductile.ui.components :as ui]
            [ductile.ui.components.combobox :as combobox]
            [ductile.ui.components.table :as table]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.http :as http]
            [ductile.ui.locale :refer [tr trn]]
            [ductile.ui.router :as router]
            [ductile.ui.schema-based-editor :as schema-based-editor]
            [ductile.ui.util :as util]
            [ductile.ui.view-stack :as view-stack]
            [ductile.ui.workflow :as workflow]
            [ductile.workflow.form-recorder :as rec]
            [inside-out.forms :as forms]
            [inside-out.reagent :refer [with-form]]
            [lambdaisland.deep-diff2 :as ddiff]
            [lambdaisland.deep-diff2.diff-impl :as diff-impl]
            [nextjournal.clerk.render.hooks :as hooks]
            [nextjournal.clerk.viewer :as clerk-viewer]
            [reagent.core :as reagent])
  (:require-macros [ductile.ui.macros :refer [defc]]
                   [ductile.ui.scope.macros :refer [when-current-user-write-scope]]))

(defn template-name [template]
  (str (or (:billing-template/name template)
           (:elog/billing-customer template))))

(def template-option-choices
  [:template-option/storage
   :template-option/accessories
   :template-option/entry
   :template-option/fueling])

(def template-option-descriptions
  {:template-option/storage :template-option/description-storage
   :template-option/accessories :template-option/description-accessories
   :template-option/entry :template-option/description-entry})

(defn new-contract-form-params [attrs _form-map]
  (-> attrs
      (update :contract/template-options #(set (or % #{})))
      (update :ductile/compounds
              (fn [compounds]
                (->> schema/compound-names
                     (filter (set (or compounds #{})))
                     vec)))))


(defn contract-form [{:as args :keys [contracts !params on-submit]}]
  (reagent/with-let [!selected-template-name (reagent/atom nil)]
    (let [{:keys [template-id]} @!params
          billing-template (->> contracts
                                (mapcat :contract/billing-templates)
                                (some #(when (= template-id (:ductile/id %)) %)))
          contract (->> contracts
                        (some #(when ((into #{} (map :ductile/id (:contract/billing-templates %))) template-id) %)))
          billing-template (if (and (not billing-template) contract)
                             (last (:contract/billing-templates contract))
                             billing-template)]
      (when (and billing-template (nil? @!selected-template-name))
        (reset! !selected-template-name (:billing-template/name billing-template)))
      (with-form [!form {:contract-id ?contract-id
                         :contract-name ?contract-name
                         :template-id ?template-id
                         :prices-from ?prices-from}
                  :init {?template-id template-id}
                  :required [?contract-id ?template-id]]
        (when (and (nil? @?contract-name) (:contract/name contract))
          (reset! ?contract-name (:contract/name contract)))

        (when (and (nil? @?contract-id) (:ductile/id contract))
          (reset! ?contract-id (:ductile/id contract)))


        [:div.rounded-lg.border.border-slate-300.shadow-lg.mx-auto.max-w-4xl
         [:div.px-5.py-2.bg-slate-100.border-b.border-slate-300.rounded-t-md
          [:div.text-base.font-bold (tr "Select customer data")]]
         [:form.bg-slate-50
          {:on-submit (fn [event]
                        (.preventDefault event)
                        (forms/try-submit+
                         !form
                         (do
                           (swap! !params #(merge % @!form))
                           (when on-submit
                             (on-submit @!form)))))}
          [:div.flex.gap-6.border-b.pb-6.p-6
           [:div
            [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
             (tr "Customer order")]
            [:div
             (let [contract-choices (mapv (fn [contract]
                                            {:ui/value (:ductile/id contract)
                                             :ui/label (:contract/name contract)}) contracts)]
               [combobox/view
                {:placeholder (tr "Select customer order")
                 :size 3
                 :choices contract-choices
                 :value (some #(when (and (= @?contract-id (:ui/value %))
                                          (= @?contract-name (:ui/label %))) %) contract-choices)
                 :on-change #(do (reset! ?contract-id (:ui/value %))
                                 (reset! ?contract-name (:ui/label %)))}])]]
           (when-let [contract (some #(when (and (= @?contract-id (:ductile/id %))
                                                 ;; TODO: drop matching by name once v2 is out
                                                 (= @?contract-name (:contract/name %))) %) contracts)]
             (let [template-name-choices (->> (:contract/billing-templates contract)
                                              (map :billing-template/name) set sort
                                              (mapv (fn [template-name]
                                                      {:ui/value template-name
                                                       :ui/label template-name})))
                   selected-template-name (or @!selected-template-name
                                              (:ui/value (first template-name-choices)))]

               [:div
                [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
                 (tr "Billing")]
                [:div
                 [combobox/view
                  {:placeholder (tr "Select billing")
                   :size 3
                   :choices template-name-choices
                   :value selected-template-name
                   :on-change #(reset! !selected-template-name (:ui/value %))}]]]))

           ;; TODO: drop matching by name once v2 is out
           (let [contract (some #(when (and (= @?contract-id (:ductile/id %))
                                            (= @?contract-name (:contract/name %))) %) contracts)]
             (when (and contract @!selected-template-name)
               [:div
                [:div.uppercase.tracking-wide.text-xs.mb-2.font-medium
                 (tr "valid from")]
                [:div
                 (let [template-choices (mapv (fn [template] {:ui/value (:ductile/id template)
                                                              :ui/label (time.format/->str {:format :date} (:billing-template/valid-from template))})
                                              (->> contract :contract/billing-templates
                                                   (filter (comp #{@!selected-template-name} :billing-template/name))
                                                   (sort-by :billing-template/valid-from)))]
                   [combobox/view
                    {:placeholder (tr "Select date")
                     :size 3
                     :choices template-choices
                     :value (or (some #(when (= @?template-id (:ui/value %)) (:ui/value %)) template-choices)
                                (do
                                  (reset! ?template-id (:ui/value (last template-choices)))

                                  (swap! !params assoc :template-id (:ui/value (last template-choices)))
                                  (last template-choices)))
                     :on-change #(reset! ?template-id (:ui/value %))}])]]))]
          [:div.px-6.py-3.flex.items-center.gap-2.bg-slate-100
           [ui/button {:size 3
                       :variant :primary
                       :type "submit"} (tr "Show")]]]]))))


(defn render-show [{:as match :keys [query-params]}]
  (let [choices (http/use-lambda 'ductile.contract/fetch-choices {})
        !results-promise (hooks/use-state nil)
        on-preview (fn [params]
                     (when-let [template-id (:template-id params)]
                       (.pushState js/window.history nil nil (str "?" (util/map->url-encoded-query-params {:template-id (with-out-str (prn template-id))}))))
                     (reset! !results-promise (http/$lambda 'ductile.contract/$billing-template params)))
        params-from-query (util/parse-query-params query-params #{:billing-year-month :customer-name :customer-id :contract-name})
        !params (hooks/use-state params-from-query)]
    (hooks/use-effect (fn []
                        (when (seq params-from-query)
                          (on-preview params-from-query))))
    [:div.p-5
     [contract-form (merge choices {:!params !params :on-submit on-preview})]
     (when @!results-promise
       [ui/loading-promise-view identity @!results-promise])]))

(defc sidebar-view [tree]
  (into [:div.text-xs.flex.flex-col.gap-2]
        (map (fn contract-sidebar-item [{:as contract contract-name :contract/name id :ductile/id}]
               [:div
                [ui/link {:on-click #(router/navigate-to (router/path '[contract-terms :ductile/id] {:ductile/id (str id)}))}
                 contract-name]
                (when (seq (:contract/subcontracts contract))
                  [:div.mt-2.ml-2 (sidebar-view contract)])]))
        (:contract/subcontracts tree)))

(defn find-contract
  [tree contract-id]
  (let [some-indexed (fn [f coll]
                       (first
                        (keep-indexed (fn [i x] (f i x)) coll)))
        walk (fn walk [node path]
               (cond
                 (= (:ductile/id node) contract-id)
                 {:path path :contract node}

                 (seq (:contract/subcontracts node))
                 (some-indexed
                  (fn [i child]
                    (walk child (conj path :contract/subcontracts i)))
                  (:contract/subcontracts node))))]
    (walk tree [])))

(defn find-currently-valid-terms
  [all-terms]
  (let [now (js/Date.)
        sorted-terms (->> all-terms
                          (sort-by :contract-terms/valid-from)
                          reverse)]
    (or (some (fn [terms]
                (when-let [valid-from (:contract-terms/valid-from terms)]
                  (when (<= valid-from now) terms)))
              sorted-terms)
        ; when all are in future
        (first sorted-terms))))

(defn terms-validity-label [terms]
  (let [valid-from (:contract-terms/valid-from terms)]
    (if valid-from
      (time.format/->str {:format :date} valid-from)
      (tr "Unknown date"))))

(declare open-new-validity-period!)

(defn terms-period-label [terms]
  (terms-validity-label terms))

(defn timestamp-label [timestamp]
  (when timestamp
    (time.format/->str {:format :datetime :style :short} timestamp)))

(defn change-timestamp-label [change]
  (timestamp-label (:ductile/timestamp change)))

(defn edited-terms-value [entry]
  (cond
    (nil? entry) nil
    (contains? entry ::edited-terms-value) (::edited-terms-value entry)
    :else entry))

(defn edited-terms-updated-at [entry]
  (when (map? entry)
    (::edited-terms-updated-at entry)))

(defn edited-terms-entry [terms]
  {::edited-terms-value terms
   ::edited-terms-updated-at (js/Date.)})

(defn active-badge
  ([] (active-badge {}))
  ([{:keys [class]}]
   [:span {:class (ui/class-vec
                   "inline-flex items-center rounded-[3px] bg-[#34c759] px-[6px] py-[2px] text-[10px] font-medium leading-none lowercase text-white"
                   class)}
    (tr "Active")]))

(defn new-badge []
  [:span.inline-flex.items-center.opacity-70
   [ui/badge {:variant :yellow :size 1} [:span.uppercase.tracking-wide.font-normal (tr "New")]]])

(defn draft-badge []
  [:span {:class "inline-flex items-center rounded-[3px] bg-orange-500 px-[6px] py-[2px] text-[10px] font-medium leading-none text-white"}
   (tr "Draft")])

(defn remove-draft-contract! [contract-name]
  (when (js/window.confirm (tr "Delete draft contract \"%1\"? This will also delete all existing change history for this contract." contract-name))
    (-> (http/$lambda 'ductile.contract-terms/remove-draft-contract
                      {:contract/name contract-name})
        (.then
         (fn [result]
           (if (:error result)
             (ui/toast! {:variant :error
                         :duration js/Infinity
                         :title (tr "Failed to delete draft contract")
                         :description [:div {:style {:margin "-15px" :overflow "hidden"}}
                                       [ui/expected-error-view result]]})
             (do
               (ui/toast! {:title (tr "Draft contract deleted")
                           :duration 3000})
               (deframe/route-refetch!)))))
        (.catch
         (fn [_err]
           (ui/toast! {:variant :error
                       :title (tr "Failed to delete draft contract")
                       :duration 5000}))))))

(defn status-dot [class-name]
  [:span {:class (ui/class-vec "h-2.5 w-2.5 rounded-full flex-shrink-0" class-name)}])

(defn change-version-tab [{:keys [active? label on-click timestamp tone]}]
  [:button
   {:type "button"
    :class (ui/class-vec
            ["inline-flex" "items-center" "gap-2" "rounded-t-md" "border" "px-4" "py-2.5" "text-[12px]" "font-medium" "leading-none" "transition-colors"]
            (if active?
              ["border-slate-200" "border-b-white" "bg-white" "text-slate-900"]
              (case tone
                :orange ["border-slate-200" "bg-white" "text-slate-900" "hover:bg-slate-50"]
                :green ["border-slate-200" "bg-slate-100" "text-slate-700" "hover:bg-slate-50"]
                ["border-slate-200" "bg-slate-100" "text-slate-700" "hover:bg-slate-50"])))
    :on-click on-click}
   [status-dot (case tone
                 :orange "bg-orange-400"
                 :green "bg-green-500"
                 "bg-slate-300")]
   [:span {:class "whitespace-nowrap"}
    (str label (when timestamp (str " (" timestamp ")")))]])

(defn validity-period-dropdown [{:keys [all-edited contract current-edited existing-vfs sorted-terms terms selected-index currently-valid-index]}]
  (let [now (js/Date.)
        selected-label (if terms
                         (terms-period-label terms)
                         (tr "New validity period"))]
    [ui/dropdown
     {:align :start
      :anchor-class "flex"
      :menu-class ui/nav-dropdown-menu-class
      :side-offset 8
      :button
      [:div {:class "flex cursor-pointer flex-col justify-center select-none hover:opacity-90"}
       [:div {:class "flex items-center gap-1 py-[0.35rem] text-[12px] font-medium leading-none text-slate-800"}
        [:span selected-label]
        [ui/icon {:size 12 :class "text-slate-400"} :chevron-down]]]
      :items
      (into
       [:div {:class "py-1"}]
       (concat
        (if (seq sorted-terms)
          (map-indexed
           (fn [index t]
             (let [vf (:contract-terms/valid-from t)
                   active? (and vf (<= vf now) (= index currently-valid-index))
                   new? (and vf (not (existing-vfs vf)))
                   current? (= index selected-index)]
               ^{:key (str "validity-period-" vf)}
               [ui/nav-dropdown-link
                {:class "justify-start"
                 :disabled? current?
                 :style {:width "100%"}
                 :on-click #(deframe/route-assoc! ::selected-terms-index index)}
                [:span {:class "flex w-full items-center gap-2"}
                 [:span {:class "flex w-3 justify-center"}
                  (when current?
                    [ui/icon {:size 11 :class "text-slate-400"} :check])]
                 [:span {:class (ui/class-vec "font-medium" (when current? "text-indigo-700"))}
                  (terms-period-label t)]
                 (when active?
                   [active-badge])
                 (when new?
                   [new-badge])]]))
           sorted-terms)
          [[:div {:class "px-3 py-2 text-[12px] text-slate-400"}
            (tr "No validity periods yet")]])
        [[:div {:class "my-1 h-px bg-slate-200"}]
         [ui/nav-dropdown-link
          {:class "justify-start"
           :style {:width "100%"}
           :on-click #(open-new-validity-period! {:contract contract
                                                  :terms (or current-edited terms)
                                                  :sorted-terms sorted-terms
                                                  :all-edited all-edited})}
          [:span {:class "flex w-full items-center gap-2"}
           [:span {:class "flex w-3 justify-center"}
            [ui/icon {:size 14} :plus]]
           [:span {:class "font-medium"} (tr "New validity period")]]]]))}]))

(defn default-valid-from []
  (let [date (js/Date.)]
    (doto date
      (.setHours 0)
      (.setMinutes 0)
      (.setSeconds 0)
      (.setMilliseconds 0)
      (.setDate 1)
      (.setMonth (inc (.getMonth date))))))

(defn new-validity-period-default-terms [contract terms sorted-terms]
  (-> (or terms
          (first sorted-terms)
          {:contract/name (:contract/name contract)
           :ductile/compounds []
           :billing-template/services []
           :contract/billing-templates []})
      (dissoc :contract-terms/change)))

(defn open-new-validity-period! [{:keys [contract terms sorted-terms all-edited]}]
  (let [form-id (str (random-uuid))]
    (view-stack/push-view!
     {:view/type :form-direct
      :view/id form-id
      :view/result {:form/name (tr "New validity period")
                    :ui/form-title (tr "New validity period")
                    :ui/fields [{:ui/attr :contract-terms/valid-from
                                 :ui/label (tr "Valid from")
                                 :ui/default-value (default-valid-from)
                                 :ui/field-view :ui.view/date}]
                    :form/path [::new-validity-form form-id]
                    :form/on-submit (fn [attrs]
                                      (let [new-term (-> (new-validity-period-default-terms contract terms sorted-terms)
                                                         (assoc :contract-terms/valid-from
                                                                (:contract-terms/valid-from attrs)))
                                            valid-from (:contract-terms/valid-from new-term)
                                            edits (or all-edited {})
                                            selected-index (->> sorted-terms
                                                                (remove #(= valid-from (:contract-terms/valid-from %)))
                                                                (cons new-term)
                                                                (sort-by :contract-terms/valid-from)
                                                                reverse
                                                                (map-indexed vector)
                                                                (some (fn [[index t]]
                                                                        (when (= valid-from (:contract-terms/valid-from t))
                                                                          index))))]
                                        (deframe/assoc-in! [::edited-terms (:ductile/id contract)]
                                                           (assoc edits valid-from (edited-terms-entry new-term)))
                                        (view-stack/pop-view!)
                                        (deframe/route-assoc! ::selected-terms-index (or selected-index 0))
                                        (when (empty? sorted-terms)
                                          (deframe/route-assoc! ::terms-tab :latest))))}})))

(defn billing-preview-modal
  [{:keys [contract-id contract template on-close]}]
  (let [form-spec-path [::billing-preview-modal :form-spec]
        form-path [::billing-preview-modal :form]
        submit-result-path [:current-route/transient ::billing-preview-modal :preview]
        form-spec @(deframe/!get-in (conj form-spec-path :result))
        form-spec-error @(deframe/!get-in (conj form-spec-path :error))
        preview-result @(deframe/!get-in (conj submit-result-path :result))]
    (hooks/use-effect
     (fn []
       (when (and contract-id (:ductile/id template))
         (deframe/call-lambda {:result-path form-spec-path}
                              'ductile.billing/inline-preview-form
                              {:template-id (:ductile/id template)
                               :compound-names (into #{} (map :compound/name) (:ductile/compounds contract))
                               :contract contract}))
       #(deframe/route-dissoc-in! [::billing-preview-modal]))
     [contract-id
      (:ductile/id template)
      (pr-str contract)])

    [ui/modal {:on-close #(do
                            (deframe/dissoc! ::billing-preview-modal)
                            (on-close))
               :attrs {:class "w-[90vw] max-w-[80rem]"}
               :close-attrs {:class "absolute top-0 right-0 text-gray-300 hover:text-gray-500 cursor-pointer absolute top-2 right-2 rounded p-2 bg-white cursor-pointer"
                             :style {:z-index 50}}}
     (cond
       (and (nil? form-spec) (nil? form-spec-error))
       [:div.size-96.flex.items-center.justify-center
        [ui/loading-spinner]]

       form-spec-error
       [ui/error-view form-spec-error]

       :else
       [:div
        [workflow/form (assoc form-spec
                              :form/path form-path
                              :form/submit-result-path submit-result-path
                              :form/set-query-params? false
                              :ui/css-class ["w-full"]
                              :ui/on-success #(ui/scroll-into-view! ".preview-result"))]
        (when preview-result
          [:div.py-5.px-8.preview-result
           [billing-ui/render-preview preview-result]])])]))


;; (Temporary?) Hack to get nicer stable diffs of services
;; Treat :billing-template/services vec as map keyed by :service/code
;; before diffing, so adds/removes are tracked by code not position
(defn services-vec->map
  [terms]
  (cond-> terms
    (sequential? (:billing-template/services terms))
    (update :billing-template/services
            (fn [svcs] (into {} (map (juxt :service/code identity)) svcs)))))

(defn services-map->vec
  "Convert diffed services map back to vec, ordered by new-terms (preserving reorder)."
  [diff-result new-terms]
  (cond-> diff-result
    (and (map? (:billing-template/services diff-result))
         (not (sequential? (:billing-template/services diff-result))))
    (update :billing-template/services
            (fn [svc-map]
              (let [unwrap-key (fn [k]
                                 (cond
                                   (schema-based-editor/insertion? k) (:+ k)
                                   (schema-based-editor/deletion? k) (:- k)
                                   :else k))
                    ;; Order by position in new-terms, deletions at the end
                    new-order (into {} (map-indexed (fn [i s] [(:service/code s) i]))
                                    (or (:billing-template/services new-terms) []))
                    order-of (fn [[k _]] (get new-order (unwrap-key k) ##Inf))]
                (->> svc-map
                     (sort-by order-of)
                     (mapv (fn [[k v]]
                             (cond
                               (schema-based-editor/insertion? k) (diff-impl/->Insertion v)
                               (schema-based-editor/deletion? k)  (diff-impl/->Deletion v)
                               :else v)))))))))

(defn compute-terms-diff [old-terms new-terms]
  (-> (ddiff/diff (services-vec->map old-terms)
                  (services-vec->map new-terms))
      (services-map->vec new-terms)))

(defn terms-for-valid-from [terms valid-from]
  (when valid-from
    (some #(when (= (:contract-terms/valid-from %) valid-from) %) terms)))

(defn change-terms-for-valid-from [change valid-from]
  (terms-for-valid-from (:contract/terms change) valid-from))

(defn review-changes-modal [{:keys [local-changes contract currently-valid-vf changes on-submit on-close]}]
  (let [!selection (hooks/use-state 0) ;; integer = local edit index, uuid = history change id
        !history-term-idx (hooks/use-state 0)
        !notes-ref (hooks/use-ref nil)
        sorted-changes (vec (reverse (sort-by :ductile/timestamp changes)))
        viewing-history? (uuid? @!selection)
        selected (when-not viewing-history? (nth local-changes @!selection nil))
        review-diff (when selected
                      (if (:original selected)
                        (compute-terms-diff (:original selected) (:edited selected))
                        (:edited selected)))
        review-validation-issues (hooks/use-memo #(when selected
                                                    (schema-based-editor/validation-issues schema/contract-schema
                                                                                           review-diff))
                                                 [selected review-diff])
        submit-disabled? (boolean (seq review-validation-issues))
        selected-change (when viewing-history?
                          (some #(when (= (:ductile/id %) @!selection) %) sorted-changes))
        history-terms (when selected-change
                        (vec (reverse (sort-by :contract-terms/valid-from (:contract/terms selected-change)))))
        selected-history-term (get history-terms @!history-term-idx)
        last-applied-change-id (:contract/last-applied-change-id contract)
        last-applied-history-idx (some (fn [[idx change]]
                                         (when (= (:ductile/id change) last-applied-change-id)
                                           idx))
                                       (map-indexed vector sorted-changes))
        unapplied-history-changes (if (some? last-applied-history-idx)
                                    (subvec sorted-changes 0 last-applied-history-idx)
                                    sorted-changes)
        unapplied-history-root-change (when (and (empty? local-changes)
                                                 (seq unapplied-history-changes))
                                        (first unapplied-history-changes))
        unapplied-history-children (cond
                                     (seq local-changes) unapplied-history-changes
                                     (seq unapplied-history-changes) (subvec unapplied-history-changes 1)
                                     :else [])
        applied-history-root-change (when (some? last-applied-history-idx)
                                      (nth sorted-changes last-applied-history-idx))
        applied-history-children (if (some? last-applied-history-idx)
                                   (subvec sorted-changes (inc last-applied-history-idx))
                                   [])
        prev-change (when-some [target-id (-> selected-change :event/target :ductile/id)]
                      (some #(when (= (:ductile/id %) target-id) %) sorted-changes))
        prev-matching-term (when (and selected-history-term prev-change)
                             (some #(when (= (:contract-terms/valid-from %)
                                             (:contract-terms/valid-from selected-history-term)) %)
                                   (:contract/terms prev-change)))
        history-view-value (when selected-history-term
                             (if prev-matching-term
                               (compute-terms-diff prev-matching-term selected-history-term)
                               selected-history-term))]
    (hooks/use-effect
     (fn []
       (when (and (empty? local-changes)
                  (seq sorted-changes)
                  (or (not viewing-history?)
                      (nil? selected-change)))
         (reset! !selection (:ductile/id (first sorted-changes)))
         (reset! !history-term-idx 0)))
     [(count local-changes)
      (some-> (first sorted-changes) :ductile/id)])
    (letfn [(history-change-item
              ([change] (history-change-item change {}))
              ([change {:keys [content-offset lane-center line-above? line-below? header-connector]
                        :or {content-offset 0}}]
               (let [icon-top 6
                     icon-half 7
                     icon-center (+ icon-top icon-half)
                     line-gap 3
                     line-y-offset 3
                     line-overlap 6
                     line-above-end (- icon-top line-gap)
                     line-below-start (+ icon-center icon-half line-gap)
                     note-text (:change/notes change)
                     lane-center (or lane-center (+ 16 content-offset))]
                 [:div {:class "relative"}
                  [:svg {:class "pointer-events-none absolute left-0 top-0"
                         :width (+ lane-center 12)
                         :height "100%"
                         :style {:overflow "visible"}}
                   header-connector]
                  (when line-above?
                    [:div {:class "pointer-events-none absolute rounded-full bg-slate-400"
                           :style {:left (str lane-center "px")
                                   :top (str (- line-overlap) "px")
                                   :width "1.25px"
                                   :height (str (+ line-overlap line-above-end line-y-offset) "px")
                                   :transform "translateX(-50%)"}}])
                  (when line-below?
                    [:div {:class "pointer-events-none absolute rounded-full bg-slate-400"
                           :style {:left (str lane-center "px")
                                   :top (str (+ line-below-start line-y-offset) "px")
                                   :bottom (str (- line-overlap) "px")
                                   :width "1.25px"
                                   :transform "translateX(-50%)"}}])
                  [:div {:style {:padding-left (str content-offset "px")}}
                   [:button
                    {:class (if (= (:ductile/id change) @!selection)
                              "w-full cursor-pointer rounded px-2 py-1.5 text-left bg-slate-100"
                              "w-full cursor-pointer rounded px-2 py-1.5 text-left hover:bg-slate-50")
                     :on-click #(do (reset! !selection (:ductile/id change))
                                    (reset! !history-term-idx 0))}
                    [:div {:class "flex items-center gap-2"}
                     (if (:change/pending? change)
                       [ui/icon {:size 14 :class "text-amber-600"} :clock]
                       [ui/icon {:size 14 :class "text-green-600"} :check-circled])
                     [:span {:class "text-[12px]"}
                      (str (time.format/->str {:format :datetime} (:ductile/timestamp change))
                           (when note-text (str " (" note-text ")")))]]
                    [:div {:class "ml-5 text-[11px] text-slate-500"}
                     (when-let [user (:ductile/user change)]
                       [:div {:class "mt-0.5"} (or (:user/name user) (:user/email user))])
                     [:div {:class "mt-0.5"}
                      (if (:change/pending? change)
                        (tr "not yet applied")
                        (tr "already applied"))]]]
                   (when (= (:ductile/id change) @!selection)
                     [:div {:class "mb-1 ml-6 mt-1 flex flex-col gap-0.5"}
                      (for [[idx term] (map-indexed vector history-terms)]
                        ^{:key (:contract-terms/valid-from term)}
                        [:button
                         {:class (if (= idx @!history-term-idx)
                                   "w-full rounded bg-slate-100 px-2 py-1 text-left text-[11px] font-medium text-indigo-600"
                                   "w-full rounded px-2 py-1 text-left text-[11px] text-slate-600 hover:bg-slate-100")
                          :on-click #(reset! !history-term-idx idx)}
                         (str (tr "valid from") " "
                              (terms-validity-label term))])])]])))
            (history-change-children
              ([child-changes] (history-change-children child-changes {}))
              ([child-changes {:keys [root-lane-center child-content-offset child-lane-center]
                               :or {root-lane-center 16
                                    child-content-offset 20
                                    child-lane-center 36}}]
               (when (seq child-changes)
                 (let [icon-top 6
                       icon-half 7
                       icon-center (+ icon-top icon-half)
                       branch-start-y 3
                       elbow-y (+ icon-center 2)
                       line-gap 3
                       child-elbow-end-x (- child-lane-center (+ icon-half line-gap))
                       bend-radius 6
                       branch-stroke "#94a3b8"]
                   [:div {:class "flex flex-col"}
                    (for [[idx child-change] (map-indexed vector child-changes)
                          :let [first? (zero? idx)
                                last? (= idx (dec (count child-changes)))]]
                      ^{:key (:ductile/id child-change)}
                      [history-change-item
                       child-change
                       {:content-offset child-content-offset
                        :lane-center child-lane-center
                        :line-above? (not first?)
                        :line-below? (not last?)
                        :header-connector
                        (when first?
                          [:path {:d (str "M " root-lane-center " " branch-start-y " "
                                          "L " root-lane-center " " (- elbow-y bend-radius) " "
                                          "Q " root-lane-center " " elbow-y " "
                                          (+ root-lane-center bend-radius) " " elbow-y " "
                                          "L " child-elbow-end-x " " elbow-y)
                                  :stroke branch-stroke
                                  :stroke-width 1.25
                                  :stroke-linecap "round"
                                  :stroke-linejoin "round"
                                  :fill "none"}])}])]))))
            (local-change-branch [child-changes]
              (let [root-lane-center 4
                    child-content-offset 20
                    child-lane-center 36
                    icon-top 6
                    dot-size 8
                    line-gap 3
                    line-overlap 6
                    root-line-start (+ icon-top dot-size line-gap)]
                [:div {:class "flex flex-col"}
                 [:div {:class "relative"}
                  (when (seq child-changes)
                    [:div {:class "pointer-events-none absolute rounded-full bg-slate-400"
                           :style {:left (str root-lane-center "px")
                                   :top (str root-line-start "px")
                                   :bottom (str (- line-overlap) "px")
                                   :width "1.25px"
                                   :transform "translateX(-50%)"}}])
                  [:div
                   [:div {:class "mb-1 flex items-center gap-2"}
                    [:div {:class "h-2 w-2 rounded-full bg-blue-500"}]
                    [:span {:class "font-medium text-[12px]"} (tr "Local changes")]]
                   [:div {:class "mb-1.5 ml-4 text-[12px] text-slate-500"} (tr "not yet submitted")]
                   [:div {:class "ml-4 flex flex-col gap-0.5"}
                    (for [[idx {:keys [original edited]}] (map-indexed vector local-changes)
                          :let [display-terms (or original edited)
                                new? (nil? original)
                                active? (= (:contract-terms/valid-from display-terms) currently-valid-vf)]]
                      ^{:key (:contract-terms/valid-from display-terms)}
                      [:button
                       {:class (if (and (not viewing-history?) (= idx @!selection))
                                 "w-full rounded bg-slate-100 px-2 py-1 text-left text-[11px] font-medium text-indigo-600"
                                 "w-full rounded px-2 py-1 text-left text-[11px] text-slate-600 hover:bg-slate-100")
                        :on-click #(reset! !selection idx)}
                       [:span {:class "flex flex-wrap items-center gap-1"}
                        (str (tr "valid from") " " (terms-validity-label display-terms))
                        (when active? [active-badge])
                        (when new? [new-badge])]])]
                   [:div {:class "mb-2 mt-3 ml-4"}
                    [:div {:class "mb-1 font-medium text-[12px]"} (tr "Reason for change")]
                    [:textarea
                     {:class "w-full rounded border border-slate-300 px-2.5 py-2 text-[12px]"
                      :rows 5
                      :ref (fn [el]
                             (reset! !notes-ref el)
                             (when (and el (not (.-_initialized el)))
                               (set! (.-_initialized el) true)
                               (set! (.-value el) (or @(deframe/!get ::change-notes) ""))))
                      :on-change #(deframe/assoc! ::change-notes (.. % -target -value))
                      :placeholder (str (tr "Describe the changes") "…")}]]
                   [:div {:class "mb-5 ml-4"}
                    [ui/button {:variant :primary
                                :class "w-full"
                                :disabled? submit-disabled?
                                :on-click #(on-submit {:change/notes (some-> @!notes-ref .-value not-empty)})}
                     (tr "Submit change request")]
                    (when submit-disabled?
                      [:div {:class "mt-1 font-medium text-[11px] text-red-800"}
                       (tr "Resolve validation errors before submitting")])]]]
                 [history-change-children child-changes {:root-lane-center root-lane-center
                                                         :child-content-offset child-content-offset
                                                         :child-lane-center child-lane-center}]]))
            (history-change-branch [root-change child-changes]
              (when root-change
                [:div {:class "flex flex-col"}
                 [history-change-item root-change {:line-below? (seq child-changes)}]
                 [history-change-children child-changes]]))]
      [ui/modal {:on-close on-close
                 :attrs {:class "w-[90vw] max-w-[1100px]"}}
       [:div {:class "flex h-[80vh] text-[12px]"}
        ;; Left sidebar
        [:div {:class "flex w-72 shrink-0 flex-col border-r border-slate-200"}
         [:div {:class "border-b border-slate-200 px-3 py-2.5"}
          [:div {:class "font-semibold text-[12px]"} (tr "Changes")]]
         [:div {:class "flex-1 overflow-auto p-3"}
          [:div {:class "flex flex-col gap-3"}
           (when (seq local-changes)
             [local-change-branch unapplied-history-children])
           (when unapplied-history-root-change
             [history-change-branch unapplied-history-root-change unapplied-history-children])
           (when applied-history-root-change
             [:div {:class (ui/class-vec
                            "flex flex-col"
                            (when (or (seq local-changes)
                                      unapplied-history-root-change)
                              "pt-1"))}
              [history-change-branch applied-history-root-change applied-history-children]])]]]
        ;; Right content
        [:div {:class "flex-1 overflow-auto p-3.5"}
         (cond
         ;; History change selected
           selected-history-term
           [:div
            [:div {:class "flex items-center text-[12px] text-slate-500"}
             [:span (tr "Contracts")]
             [:span {:class "mx-2"} "/"]
             [:span {:class "font-medium text-slate-800"} (or (:contract/name contract) "")]
             [:span {:class "mx-2"} "/"]
             [:span (tr "Change history")]
             [:span {:class "mx-2"} "/"]
             [:span (time.format/->str {:format :datetime} (:ductile/timestamp selected-change))]]
            [:div {:class "pt-3"}
             [:div {:class "flex items-center gap-2 font-semibold text-[12px]"}
              [:span (tr "valid from")]
              [:span {:class "text-[11px] font-medium text-slate-600"}
               (time.format/->str {:format :date :style :long}
                                  (:contract-terms/valid-from selected-history-term))]
              (when (= (:contract-terms/valid-from selected-history-term) currently-valid-vf)
                [active-badge])]
             [:div {:class "pt-1.5"}
              [schema-based-editor/editor
               {:validate? false
                :value history-view-value
                :editable-paths #{}
                :schema schema/contract-schema}]]]]

         ;; Current edit selected
           selected
           [:div
            [:div {:class "flex items-center text-[12px] text-slate-500"}
             [:span (tr "Contracts")]
             [:span {:class "mx-2"} "/"]
             [:span {:class "font-medium text-slate-800"} (or (:contract/name contract) "")]
             [:span {:class "mx-2"} "/"]
             [:span (tr "Change history")]]
            [:div {:class "pt-3"}
             (let [display-terms (or (:original selected) (:edited selected))]
               [:div {:class "flex items-center gap-2 font-semibold text-[12px]"}
                [:span (tr "valid from")]
                [:span {:class "text-[11px] font-medium text-slate-600"}
                 (time.format/->str {:format :date :style :long}
                                    (:contract-terms/valid-from display-terms))]
                (when (nil? (:original selected))
                  [new-badge])
                (when (= (:contract-terms/valid-from display-terms) currently-valid-vf)
                  [active-badge])])

             [:div {:class "pt-1.5"}
              [schema-based-editor/editor
               {:validate? true
                :value review-diff
                :editable-paths #{}
                :schema schema/contract-schema}]]


             (when (ui/debug-mode?)
               [:div {:class "text-[11px]"}
                [:div (pr-str review-diff)]])]])]]])))


(def has-terms? (comp some? :contract/last-applied-change-id))

(defn flatten-contracts
  [tree]
  (letfn [(walk [nodes depth ancestor-with-terms]
            (mapcat (fn [c]
                      (let [next-ancestor (if (has-terms? c)
                                            (:contract/name c)
                                            ancestor-with-terms)]
                        (cons (assoc c ::depth depth ::ancestor-with-terms ancestor-with-terms)
                              (walk (:contract/subcontracts c) (inc depth) next-ancestor))))
                    nodes))]
    (walk (:contract/subcontracts tree) 0 nil)))

(defn select-col [!selected-col compound]
  (swap! !selected-col (fn [v] (when (not= v compound) compound))))

(defn compound-matrix [tree]
  (let [contracts (flatten-contracts tree)
        all-compounds (->> contracts
                           (mapcat :ductile/compounds)
                           (keep :compound/name)
                           distinct
                           sort
                           vec)
        !hovered-row (hooks/use-state nil)
        !hovered-col (hooks/use-state nil)
        !selected-col (hooks/use-state nil)
        selected @!selected-col]
    [:div.mt-4 {:class "text-[13px]"}
     [:table.w-auto.border-collapse
      [:thead
       [:tr
        [:th.sticky.left-0.top-0.z-30.bg-white.text-left.text-base.align-bottom.pl-1.pb-2
         {:style {:box-shadow "0 1px 0 #e2e8f0"}}
         (tr "Contracts")]
        (doall (for [[idx compound] (map-indexed vector all-compounds)]
                 [:th.sticky.top-0.relative.cursor-pointer.select-none
                  {:key compound
                   :class (str "px-3 pt-16 pb-2 align-bottom font-normal bg-white "
                               (cond
                                 (= compound selected) "text-indigo-600 "
                                 (= compound @!hovered-col) "text-slate-500 "
                                 :else "text-slate-400 "))
                   :style {:z-index (- 29 idx) :box-shadow "0 1px 0 #e2e8f0"}
                   :on-click #(select-col !selected-col compound)
                   :on-mouse-enter #(reset! !hovered-col compound)
                   :on-mouse-leave #(reset! !hovered-col nil)}
                  [:div.absolute.bottom-2.whitespace-nowrap
                   {:style {:left "50%"
                            :transform "rotate(-50deg)"
                            :transform-origin "bottom left"}}
                   compound]]))]]
      [:tbody
       (doall (for [{:as contract contract-name :contract/name id :ductile/id} contracts
                    :let [compounds (into #{} (map :compound/name) (:ductile/compounds contract))
                          row-key (str id)
                          filtered-out? (and selected (not (compounds selected)))
                          depth (::depth contract)]]
                [:tr {:key row-key
                      :class (when (= row-key @!hovered-row) "bg-slate-50 ")
                      :on-mouse-enter #(reset! !hovered-row row-key)
                      :on-mouse-leave #(reset! !hovered-row nil)}
                 [:td.sticky.left-0.z-10.bg-white.px-2.py-1.whitespace-nowrap.border-r.border-slate-200
                  {:class (when (= row-key @!hovered-row) "!bg-slate-50")}
                  [:div.flex.items-center.gap-1 {:style {:padding-left (str (* depth 16) "px")}}
                   [ui/link {:href (router/path '[contract-terms :ductile/id] {:ductile/id (str id)})
                             :class (when filtered-out? "text-slate-300")}
                    contract-name]
                   (when (:contract/draft? contract)
                     [:<>
                      [draft-badge]
                      [:span {:class "text-[11px] text-slate-400"}
                       " ("
                       [ui/link {:class "text-red-500 hover:text-red-700"
                                 :on-click #(remove-draft-contract! contract-name)}
                        (tr "Delete")]
                       ")"]])
                   (when-not (has-terms? contract)
                     (let [ancestor (::ancestor-with-terms contract)]
                       [ui/tooltip {:content (if ancestor
                                               (str (tr "This contract has no own terms. The terms of the parent contract apply:") " " ancestor)
                                               (tr "This contract has no terms."))}
                        [:span.text-slate-300 [ui/icon (if ancestor :link-2 :link-none-2)]]]))]]
                 (doall (for [compound all-compounds]
                          [:td.text-center.px-3.py-1.cursor-pointer
                           {:key compound
                            :class (str (cond
                                          (= compound selected) "bg-indigo-50 "
                                          (= compound @!hovered-col) "bg-slate-50 "))
                            :on-click #(select-col !selected-col compound)
                            :on-mouse-enter #(reset! !hovered-col compound)
                            :on-mouse-leave #(reset! !hovered-col nil)}
                           (when (compounds compound)
                             [:span.text-indigo-600 {:class "text-[18px]"}
                              [:span.inline-block.rounded-full.bg-indigo-600.size-2]])]))]))]]]))

(defn find-parent-with-terms [tree path]
  (loop [p path]
    (when (seq p)
      (let [parent-path (vec (drop-last 2 p))
            parent (get-in tree parent-path)]
        (if (has-terms? parent)
          parent
          (recur parent-path))))))

(defn overview [tree match]
  (let [contract-id (some-> (:ductile/id (deframe/current-route-params))
                            str parse-uuid)
        {contract :contract contract-path :path} (when contract-id (find-contract tree contract-id))
        all-edited @(deframe/!get-in [::edited-terms contract-id])
        !billing-preview-request (hooks/use-state nil)
        !editor-editing-path (hooks/use-state nil)
        !previous-editor-editing-path (hooks/use-ref nil)
        changes (:contract-terms/changes contract)
        sorted-changes (->> changes
                            (sort-by (juxt :ductile/timestamp :ductile/id))
                            vec)
        pending-changes (not-empty (filterv :change/pending? sorted-changes))
        applied-changes (filterv :change/applied-at sorted-changes)
        last-pending-change (last pending-changes)
        last-pending-change-id (:ductile/id last-pending-change)
        last-applied-change-id (:contract/last-applied-change-id contract)
        last-applied-change (or (some #(when (= (:ductile/id %) last-applied-change-id) %) sorted-changes)
                                (last applied-changes))
        latest-server-change (or last-pending-change last-applied-change)
        server-terms (:contract/terms latest-server-change)
        server-terms-by-vf (into {} (map (juxt :contract-terms/valid-from identity)) server-terms)
        existing-vfs (set (map :contract-terms/valid-from server-terms))
        new-terms (for [[vf edited-entry] all-edited
                        :let [t (edited-terms-value edited-entry)]
                        :when (and t (not (existing-vfs vf)))]
                    t)
        all-terms (concat server-terms new-terms)
        sorted-terms (->> all-terms
                          (sort-by :contract-terms/valid-from)
                          reverse
                          vec)
        currently-valid (find-currently-valid-terms all-terms)
        currently-valid-index (when currently-valid
                                (some (fn [[index t]]
                                        (when (= (:contract-terms/valid-from t)
                                                 (:contract-terms/valid-from currently-valid))
                                          index))
                                      (map-indexed vector sorted-terms)))
        selected-index (or @(deframe/!route-get ::selected-terms-index) currently-valid-index 0)

        terms (get sorted-terms selected-index)
        selected-valid-from (:contract-terms/valid-from terms)
        selected-server-terms (get server-terms-by-vf selected-valid-from)

        now (js/Date.)
        all-applied? (and (seq changes) (empty? pending-changes))
        current-edited-entry (get all-edited selected-valid-from)
        current-edited (edited-terms-value current-edited-entry)
        current-edited-at (edited-terms-updated-at current-edited-entry)
        changes-by-id (into {} (map (juxt :ductile/id identity)) sorted-changes)
        prev-change-of (fn [change]
                         (get changes-by-id (-> change :event/target :ductile/id)))
        change-affects-selected-validity?
        (fn [change]
          (when selected-valid-from
            (not= (change-terms-for-valid-from (prev-change-of change) selected-valid-from)
                  (change-terms-for-valid-from change selected-valid-from))))
        relevant-pending-changes (vec (filter change-affects-selected-validity? pending-changes))
        latest-relevant-pending-change (last relevant-pending-changes)
        previous-relevant-pending-change (nth relevant-pending-changes (- (count relevant-pending-changes) 2) nil)
        relevant-applied-changes (vec (filter change-affects-selected-validity? applied-changes))
        latest-relevant-applied-change (last relevant-applied-changes)
        active-tab-change (or latest-relevant-applied-change last-applied-change)
        active-terms (change-terms-for-valid-from last-applied-change selected-valid-from)
        live-diff-value (when (and current-edited (not= current-edited terms))
                          (compute-terms-diff terms current-edited))
        submitted-diff-value (when (and (not current-edited) latest-relevant-pending-change)
                               (let [previous-terms (or (change-terms-for-valid-from previous-relevant-pending-change selected-valid-from)
                                                        active-terms)]
                                 (if previous-terms
                                   (compute-terms-diff previous-terms terms)
                                   terms)))
        local-changes (when (seq all-edited)
                        (->> all-terms
                             (keep (fn [t]
                                     (let [vf (:contract-terms/valid-from t)
                                           edited-entry (get all-edited vf)
                                           edited (edited-terms-value edited-entry)]
                                       (cond
                                         (not (existing-vfs vf)) {:original nil
                                                                  :edited t
                                                                  :valid-from vf
                                                                  :updated-at (edited-terms-updated-at edited-entry)}
                                         (and edited (not= edited t)) {:original t
                                                                       :edited edited
                                                                       :valid-from vf
                                                                       :updated-at (edited-terms-updated-at edited-entry)}))))
                             (sort-by (comp :contract-terms/valid-from #(or (:original %) (:edited %))))
                             reverse
                             vec))
        has-local-changes? (seq local-changes)
        all-terms-with-edits (when has-local-changes?
                               (mapv (fn [t]
                                       (or (edited-terms-value (get all-edited (:contract-terms/valid-from t))) t))
                                     all-terms))
        local-changes-by-validity (when has-local-changes?
                                    (->> local-changes
                                         (group-by :valid-from)
                                         (sort-by (fn [[vf _]]
                                                    (or (some-> vf (.valueOf)) 0))
                                                  >)
                                         (map (fn [[vf changes]]
                                                (str (terms-validity-label {:contract-terms/valid-from vf})
                                                     ": "
                                                     (count changes))))
                                         vec))
        latest-tab-timestamp (or (timestamp-label current-edited-at)
                                 (some-> latest-relevant-pending-change change-timestamp-label))
        show-last-changes-tab? (boolean (or current-edited latest-relevant-pending-change))
        selected-tab-route @(deframe/!route-get ::terms-tab nil)
        selected-tab (if show-last-changes-tab?
                       (or selected-tab-route
                           (when (or current-edited latest-relevant-pending-change) :latest)
                           :active)
                       :active)
        diff-view? (boolean (and (= selected-tab :latest)
                                 (or current-edited latest-relevant-pending-change)))
        selected-validity-status (let [vf (:contract-terms/valid-from terms)]
                                   (cond
                                     (and vf (<= vf now) (= selected-index currently-valid-index)) [active-badge]
                                     (and vf (not (existing-vfs vf))) [new-badge]))
        version-tabs (vec
                      (remove nil?
                              [(when show-last-changes-tab?
                                 {:id :latest
                                  :label (if active-terms
                                           (tr "Latest changes")
                                           (tr "Current version"))
                                  :timestamp latest-tab-timestamp
                                  :tone :orange})
                               (when active-terms
                                 {:id :active
                                  :label (tr "Currently active version")
                                  :timestamp (some-> active-tab-change change-timestamp-label)
                                  :tone :green})]))
        discard-local-changes! (fn []
                                 (when (js/window.confirm (tr "Discard all local changes?"))
                                   (deframe/assoc-in! [::edited-terms contract-id] nil)))
        local-summary-content (when has-local-changes?
                                [:<>
                                 [:span
                                  (trn ["%1 local change is pending review"
                                        "%1 local changes are pending review"]
                                       (count local-changes))]
                                 [:span {:class "font-normal text-orange-700/90"}
                                  " ("
                                  [ui/link
                                   {:class "text-orange-700 hover:text-orange-800 hover:underline hover:decoration-orange-400/80 hover:underline-offset-2"
                                    :on-click discard-local-changes!}
                                   (tr "Discard changes")]
                                  ")"]])
        pending-summary-text (when (seq pending-changes)
                               (trn ["%1 change request is pending application"
                                     "%1 change requests are pending application"]
                                    (count pending-changes)))
        primary-summary-content (cond
                                  (and local-summary-content pending-summary-text)
                                  [:<>
                                   local-summary-content
                                   [:span ", "]
                                   [:span pending-summary-text]]

                                  local-summary-content
                                  local-summary-content

                                  pending-summary-text
                                  [:span pending-summary-text]

                                  :else nil)
        local-validity-summary (when has-local-changes?
                                 (tr "Local changes by validity: %1"
                                     (str/join " · " local-changes-by-validity)))
        summary-status (cond
                         primary-summary-content
                         {:tone :orange
                          :content primary-summary-content}

                         all-applied?
                         {:tone :green
                          :content [:span (tr "All change requests have been applied.")]}

                         :else nil)
        review-button-label (if has-local-changes?
                              (trn ["Review %1 change"
                                    "Review %1 changes"]
                                   (count local-changes))
                              (tr "Change history"))
        submit-review-change!
        (fn [extra-params]
          (-> (http/$lambda 'ductile.contract-terms/new-change-event
                            (util/dissoc-blank-vals
                             (assoc extra-params
                                    :base-change/id (:ductile/id latest-server-change)
                                    :contract/terms (->> all-terms-with-edits
                                                         (w/postwalk
                                                          (fn [v]
                                                            (if (clerk-viewer/render-fn? v)
                                                              (rec/map->WorkflowFn {:form (:form v) :f nil})
                                                              v)))))))
              (.then
               (fn [result]
                 (if (:error result)
                   (ui/toast! {:variant :error
                               :duration js/Infinity
                               :description [:div {:style {:margin "-15px" :overflow "hidden"}}
                                             [ui/expected-error-view result]]})
                   (do
                     (deframe/assoc-in! [::edited-terms contract-id] nil)
                     (deframe/route-dissoc! ::review-modal?)
                     (deframe/dissoc! ::change-notes)
                     (ui/toast! {:title (tr "Change request submitted") :duration 3000})
                     (deframe/route-refetch!)))))
              (.catch
               (fn [_err]
                 (ui/toast! {:title (tr "Failed to submit change request")
                             :duration 5000})))))
        preview-term (or current-edited terms)
        preview-template (first (:contract/billing-templates preview-term))
        open-new-contract!
        (fn []
          (let [form-id (random-uuid)
                form-path [::view-stack/view-stack-data form-id]]
            (view-stack/push-view!
             {:view/type :form-direct
              :view/id form-id
              :view/result
              {:form/name (tr "Contracts")
               :form/transform-fn new-contract-form-params
               :ui/fields [{:ui/attr :contract/name
                            :ui/field-view :ui.view/text}
                           {:ui/attr :contract/template-options
                            :ui/default-value #{}
                            :ui/descriptions template-option-descriptions
                            :ui/field-view :ui.view/multi-select
                            :ui/options template-option-choices
                            :ui/optional? true
                            :ui/schema-type :set}
                           {:ui/attr :ductile/compounds
                            :ui/default-value #{}
                            :ui/field-view :ui.view/multi-select
                            :ui/options schema/compound-names
                            :ui/optional? true
                            :ui/schema-type :set}
                           #_{:ui/attr :contract-terms/valid-from
                              :ui/label (tr "Valid from")
                              :ui/default-value (doto (js/Date.)
                                                  (.setHours 0)
                                                  (.setMinutes 0)
                                                  (.setSeconds 0)
                                                  (.setMilliseconds 0)
                                                  (.setDate 1)
                                                  (.setMonth (inc (.getMonth (js/Date.)))))
                              :ui/field-view :ui.view/date}]
               :form/path form-path
               :form/on-submit
               (fn [attrs]
                 (deframe/route-dissoc-in! (conj form-path :error))
                 (.then (http/$lambda 'ductile.contract-terms/new-contract attrs)
                        (fn [result]
                          (if (:error result)
                            (do
                              (deframe/route-assoc-in! (conj form-path :error) result)
                              (ui/scroll-into-view-with-margin! ".expected-error" {:block "center"}))
                            (when-let [id (:ductile/id result)]
                              (view-stack/pop-view!)
                              (when-some [initial-terms (:contract/initial-terms result)]
                                (deframe/assoc-in! [::edited-terms id] {(:contract-terms/valid-from initial-terms) initial-terms}))
                              (router/navigate-to
                               (router/path '[contract-terms :ductile/id]
                                            {:ductile/id (str id)})))))))}})))]

    (hooks/use-effect
     (fn []
       (when (and (.-current !previous-editor-editing-path)
                  (nil? @!editor-editing-path))
         (deframe/route-assoc! ::terms-tab (if show-last-changes-tab? :latest :active)))
       (set! (.-current !previous-editor-editing-path) @!editor-editing-path))
     [show-last-changes-tab?
      @!editor-editing-path])

    (ui/use-navigation-guard (when has-local-changes? (tr "You have unsaved changes. Leave anyway?")))

    [:div {:class "-mx-5 -mt-5 -mb-5 min-h-fit bg-slate-50 pb-8"}
     (when @!billing-preview-request
       [billing-preview-modal
        (assoc @!billing-preview-request
               :on-close #(reset! !billing-preview-request nil))])
     (when contract-id
       [:div {:class "sticky top-0 z-20 border-b border-slate-200 bg-white/95 backdrop-blur"}
        [:div {:class "flex flex-wrap items-center gap-2 px-5 py-2.5 text-[12px] text-slate-500"}
         [ui/link {:href "/contract-terms"
                   :class "transition-colors hover:text-slate-700"}
          (tr "Contracts")]
         (when-let [name (or (:contract/name contract) (:contract/name terms))]
           [:<>
            [:span {:class "text-slate-300"} "/"]
            [:span {:class "font-medium text-slate-800"} name]
            (when (:contract/draft? contract)
              [draft-badge])])
         (when contract
           [:<>
            [:span {:class "text-slate-300"} "/"]
            [validity-period-dropdown
             {:all-edited all-edited
              :contract contract
              :current-edited current-edited
              :existing-vfs existing-vfs
              :sorted-terms sorted-terms
              :terms terms
              :selected-index selected-index
              :currently-valid-index currently-valid-index}]
            selected-validity-status])]])

     [:div {:class "mx-auto max-w-[1120px] px-4 pt-8 sm:px-6"}
      (if contract-id
        [:<>
         (if-not terms
           (let [parent (find-parent-with-terms tree contract-path)]
             [:div {:class "mt-2 rounded-md border border-slate-200 bg-white p-4 text-[12px] text-slate-600 shadow-sm"}
              (if parent
                [:div {:class "flex flex-col gap-1"}
                 [:span (tr "This contract has no own terms. The terms of the parent contract apply:")]
                 [ui/link {:href (router/path '[contract-terms :ductile/id] {:ductile/id (str (:ductile/id parent))})}
                  (:contract/name parent)]]
                [:span (tr "This contract has no terms.")])])
           [:div {:class "mt-2"}
            (when (seq version-tabs)
              [:div {:class "relative z-10 mb-[-1px] flex flex-wrap gap-1.5"}
               (for [{:keys [id label timestamp tone]} version-tabs]
                 ^{:key (str "version-tab-" id)}
                 [change-version-tab
                  {:active? (= id selected-tab)
                   :label label
                   :timestamp timestamp
                   :tone tone
                   :on-click #(deframe/route-assoc! ::terms-tab id)}])])
            [:div {:class (ui/class-vec
                           "overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm"
                           (when (seq version-tabs) "rounded-tl-none"))}
             [:div {:class "flex flex-col gap-4 px-6 py-5 text-[12px] lg:flex-row lg:items-start lg:justify-between"}
              [:div {:class "min-w-0 flex-1"}
               [:div {:class "text-[18px] leading-[24px]"}
                [:span {:class "mr-1 text-slate-400"} (str (tr :contract/name) ":")]
                [:span {:class "font-semibold text-slate-900"}
                 (or (:contract/name contract) (:contract/name terms))]]
               (when summary-status
                 [:div
                  {:class (ui/class-vec
                           "mt-3 text-[12px] font-medium leading-[18px]"
                           (case (:tone summary-status)
                             :orange "text-orange-600"
                             :green "text-green-600"
                             "text-slate-500"))}
                  (:content summary-status)])
               (when local-validity-summary
                 [:div {:class "mt-1 text-[12px] leading-[18px] text-slate-400"}
                  local-validity-summary])]
              [:div {:class "flex w-full flex-col gap-2 text-[12px] lg:w-auto lg:items-end"}
               [:div {:class "flex flex-wrap gap-2 lg:justify-end"}
                (when preview-term
                  [ui/button
                   {:variant :white
                    :size 2
                    :class "rounded-md px-4"
                    :disabled? (or (nil? preview-template)
                                   (not (:ductile/id preview-template)))
                    :on-click #(reset! !billing-preview-request
                                       {:contract-id contract-id
                                        :contract (assoc contract :contract/terms (or all-terms-with-edits (vec all-terms)))
                                        :template preview-template})}
                   (tr "Invoice Preview")])
                [ui/button
                 {:variant (if has-local-changes? :primary :secondary)
                  :size 2
                  :class "rounded-md px-4"
                  :on-click #(deframe/route-assoc! ::review-modal? true)}
                 review-button-label]]]]
             [:div {:class "border-t border-slate-100"}]
             [:div {:class "px-6 pb-1.5 pt-2"}
              ^{:key (str "editor-" selected-tab "-" diff-view?)} ;; reset state when switching between plain and diff views
              [schema-based-editor/editor
               {:sticky-top-offset "3.5rem"
                :validate? true
                :editing-path @!editor-editing-path
                :on-editing-path-change #(reset! !editor-editing-path %)
                :schema schema/contract-schema
                :value (cond
                         (and @!editor-editing-path current-edited)
                         current-edited

                         (= selected-tab :active)
                         (or active-terms terms)

                         live-diff-value
                         live-diff-value

                         submitted-diff-value
                         submitted-diff-value

                         current-edited
                         current-edited

                         :else
                         terms)
                :on-change (fn [new-val]
                             (let [v (if diff-view?
                                       (schema-based-editor/strip-diff-records new-val)
                                       new-val)
                                   vf selected-valid-from
                                   edits (or all-edited {})
                                   local-new-validity? (and (contains? edits vf)
                                                            (not (existing-vfs vf)))
                                   target-vf (if local-new-validity?
                                               (:contract-terms/valid-from v)
                                               vf)
                                   edits (if (and local-new-validity?
                                                  (not= vf target-vf))
                                           (dissoc edits vf)
                                           edits)]
                               (deframe/assoc-in!
                                [::edited-terms contract-id]
                                (if (and selected-server-terms
                                         (= v selected-server-terms))
                                  (not-empty (dissoc edits vf))
                                  (assoc edits target-vf (edited-terms-entry v))))))
                :editable-paths
                (if (and
                     (contains? (set (:user/write-scopes @ductile.ui.deframe/!current-user)) :scope/billing)
                     (or (= selected-tab :latest)
                         (not show-last-changes-tab?)
                         @!editor-editing-path))
                  #{[]}
                  #{})}]]]])]
        [:div {:class "p-5"}
         [:div {:class "rounded-lg border bg-white p-5 shadow-sm"}
          [:div {:class "flex justify-between gap-2"}
           [compound-matrix tree]
           (when-current-user-write-scope
            :scope/billing
            [:div {:class "sticky top-7 self-start"}
             [ui/button
              {:variant :white
               :on-click open-new-contract!}
              [ui/icon :plus] (tr "New contract")]])]]])
      (when @(deframe/!route-get ::review-modal? false)
        [review-changes-modal
         {:local-changes local-changes
          :contract contract
          :currently-valid-vf (:contract-terms/valid-from currently-valid)
          :changes changes
          :on-close #(deframe/route-assoc! ::review-modal? false)
          :on-submit submit-review-change!}])]]))

(defn short-change-id [id]
  (let [s (str id)] (subs s (max 0 (- (count s) 12)))))

(defn changes-timeline-lane-rows
  "Lay out a list of changes (newest first) onto a forest of lanes.

   Returns a vec of rows, each row draws just one change
     :change         — the input change
     :lane           — zero-based column index where the dot is drawn
     :active-before  — set of lane indices carrying a line into this row from above
     :active-after   — set of lane indices carrying a line out below this row
     :merging        — set of lane indices that terminate at this row (sibling
                       branches rejoining their common ancestor here)
     :orphan?        — true if :event/target points at an id not in the input
     :orphan-target  — the :event/target id (useful when :orphan? is true)

   Children of the same parent branch belong to separate lanes, lanes merge where
   they rejoin a common ancestor."
  [changes]
  (let [ids (into #{} (map :ductile/id) changes)]
    (first
     (reduce
      (fn [[rows pending-parents] c]
        (let [id (:ductile/id c)
              target (get-in c [:event/target :ductile/id])
              parent-in-set? (contains? ids target)
              expecting (keep-indexed (fn [i parent] (when (= parent id) i)) pending-parents)
              lane (if (seq expecting)
                     (first expecting)
                     (or (first (keep-indexed (fn [i parent] (when (nil? parent) i)) pending-parents))
                         (count pending-parents)))
              merging (set (next expecting))
              active-before (set (keep-indexed (fn [i parent] (when (some? parent) i)) pending-parents))
              pending-parents' (-> (vec pending-parents)
                                   (cond-> (<= (count pending-parents) lane)
                                     (into (repeat (- (inc lane) (count pending-parents)) nil)))
                                   (as-> pp (reduce #(assoc %1 %2 nil) pp merging))
                                   (assoc lane (when parent-in-set? target)))
              active-after (set (keep-indexed (fn [i parent] (when (some? parent) i)) pending-parents'))]
          [(conj rows {:change c
                       :lane lane
                       :active-before active-before
                       :active-after active-after
                       :merging merging
                       :orphan? (and (some? target) (not parent-in-set?))
                       :orphan-target target})
           pending-parents']))
      [[] []]
      changes))))

(def lane-width 18)
(def dot-strip-height 20)
(def icon-radius 7)
(def line-stroke "#94a3b8")

(defn- changes-timeline-modal [{:keys [contract on-close]}]
  (let [changes (->> (:contract-terms/changes contract)
                     (sort-by (juxt :ductile/timestamp :ductile/id))
                     reverse
                     vec)
        rows (changes-timeline-lane-rows changes)
        n-lanes (->> rows
                     (mapcat (fn [{:keys [lane active-before active-after merging]}]
                               (into #{lane} (concat active-before active-after merging))))
                     (reduce max -1)
                     inc
                     (max 1))
        graphic-w (* n-lanes lane-width)
        lane-cx (fn [l] (+ (* l lane-width) (/ lane-width 2)))]
    [ui/modal {:on-close on-close
               :attrs {:class "w-[480px] max-w-[90vw]"}}
     [:div.p-6
      [:h2.text-base.font-semibold.text-slate-800.mb-5
       (str (:contract/name contract) " — " (tr "Changes"))]
      (if (empty? changes)
        [:p.text-sm.text-slate-400 (tr "No changes recorded")]
        [:div.overflow-x-auto
         [:div.flex.flex-col
          (for [[idx {:keys [change lane active-before active-after merging orphan? orphan-target]}]
                (map-indexed vector rows)
                :let [dot-cx (lane-cx lane)
                      not-last? (< idx (dec (count rows)))]]
            ^{:key (:ductile/id change)}
            [:div.flex.gap-3
             ;; left column: lane graphic
             [:div.flex.flex-col.flex-shrink-0 {:style {:width (str graphic-w "px")}}
              ;; top strip: dot, incoming lines, merging curves
              [:div.relative {:style {:height (str dot-strip-height "px")}}
               [:svg {:class "absolute inset-0"
                      :width "100%" :height "100%"
                      :viewBox (str "0 0 " graphic-w " " dot-strip-height)
                      :preserveAspectRatio "none"}
                (for [l (range n-lanes)
                      :when (and (not= l lane)
                                 (not (contains? merging l))
                                 (contains? active-before l)
                                 (contains? active-after l))]
                  ^{:key (str "through-" l)}
                  [:line {:x1 (lane-cx l) :y1 0
                          :x2 (lane-cx l) :y2 dot-strip-height
                          :stroke line-stroke :stroke-width 1}])
                (when (contains? active-before lane)
                  [:line {:key "in"
                          :x1 dot-cx :y1 0
                          :x2 dot-cx :y2 (- (/ dot-strip-height 2) icon-radius)
                          :stroke line-stroke :stroke-width 1}])
                (for [m merging
                      :let [mx (lane-cx m)
                            my (/ dot-strip-height 2)
                            end-x (if (< dot-cx mx) (+ dot-cx icon-radius) (- dot-cx icon-radius))]]
                  ^{:key (str "merge-" m)}
                  [:path {:d (str "M " mx " 0 Q " mx " " my " " end-x " " my)
                          :stroke line-stroke :stroke-width 1 :fill "none"}])]
               [:div.absolute.flex.items-center.justify-center
                {:style {:left (str (* lane lane-width) "px")
                         :top 0
                         :width (str lane-width "px")
                         :height (str dot-strip-height "px")}}
                (cond
                  orphan? [ui/icon {:size 14 :class "text-red-600"} :cross-circled]
                  (:event/undone-at change) [ui/icon {:size 14 :class "text-rose-500"} :cross-circled]
                  (:change/applied-at change) [ui/icon {:size 14 :class "text-green-600"} :check-circled]
                  :else [ui/icon {:size 14 :class "text-amber-600"} :clock])]]
              ;; bottom strip: outgoing vertical lines, fills remaining row height
              [:div.relative.flex-1
               (when (seq active-after)
                 [:svg {:class "absolute inset-0"
                        :width "100%" :height "100%"
                        :viewBox (str "0 0 " graphic-w " 10")
                        :preserveAspectRatio "none"}
                  (for [l active-after]
                    ^{:key (str "out-" l)}
                    [:line {:x1 (lane-cx l) :y1 0
                            :x2 (lane-cx l) :y2 10
                            :stroke line-stroke :stroke-width 1}])])]]
             ;; right column: timestamp + optional notes
             [:div {:class (if not-last? "pb-4" "pb-1")}
              [:div.flex.items-center.gap-2 {:style {:height (str dot-strip-height "px")}}
               [:span.text-sm.text-slate-700
                (time.format/->str (:ductile/timestamp change))]
               [:span.text-slate-300 "·"]
               [:div.flex.items-center.gap-0.5
                [:span.text-xs.font-mono.underline.text-slate-400
                 {:title (str (:ductile/id change))}
                 (short-change-id (:ductile/id change))]
                [:button.p-1.rounded.hover:bg-slate-200.cursor-pointer.text-slate-400
                 {:title (tr "Copy change id")
                  :on-click (fn []
                              (.writeText js/navigator.clipboard (str (:ductile/id change)))
                              (ui/toast! {:title (tr "Change id copied to clipboard") :duration 3000}))}
                 [ui/icon {:size 14} :copy]]]]
              (when orphan?
                [:p.text-xs.text-red-600.mt-1
                 (tr "Broken link to %1" (short-change-id orphan-target))])
              (when-some [notes (:change/notes change)]
                [:p.text-xs.text-slate-500.mt-1 notes])]])]])]]))

(defc terms-dashboard [{:keys [contracts]} _match]
  (reagent/with-let [!open-contract (reagent/atom nil)]
    [:div
     (when @!open-contract
       [changes-timeline-modal {:contract @!open-contract
                                :on-close #(reset! !open-contract nil)}])
     [ui/page-title (tr "Contract Terms Dashboard")]
     [:div.w-full.overflow-auto.rounded.border.border-slate-300.shadow
      [table/table
       {:column-order [:contract/name :contract/last-applied-change :contract/last-pending-change :contract/last-pending-change-id]
        :schema [:contract/name :contract/last-applied-change :contract/last-pending-change :contract/last-pending-change-id]
        :transform-columns
        {[:contract/name] (fn [row]
                            [:div.flex.items-center.gap-1
                             [:button.p-1.rounded.hover:bg-slate-200.cursor-pointer.text-slate-400.hover:text-slate-700
                              {:on-click #(reset! !open-contract row)
                               :title (tr "Show change history")}
                              [ui/icon {:size 14} :counter-clockwise-clock]]
                             [:span (:contract/name row)]])
         [:contract/last-applied-change] (comp time.format/->str :change/applied-at :contract/last-applied-change)
         [:contract/last-pending-change] (comp time.format/->str :ductile/timestamp :contract/last-pending-change)
         [:contract/last-pending-change-id] (fn [row]
                                              (when-let [id (some-> row :contract/last-pending-change :ductile/id)]
                                                [:div.flex.items-center.gap-1
                                                 [:span.text-xs.font-mono.underline {:title (str id)} (subs (str id) (- (count (str id)) 12))]
                                                 [:button.p-1.rounded.hover:bg-slate-200.cursor-pointer
                                                  {:title (tr "Copy change id")
                                                   :on-click (fn []
                                                               (.writeText js/navigator.clipboard (str id))
                                                               (ui/toast! {:title (tr "Change id copied to clipboard") :duration 3000}))}
                                                  [ui/icon {:size 14} :copy]]]))}}
       contracts]]]))

(comment
  @(deframe/!get-in [:current-route/transient :fetch :result :contract/subcontracts 14]))
